import { useCallback, useMemo, useState } from 'react';
import { type MenuOption } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../../shared/hooks';

import { MC_LIST_SORT_ACTIONS, MC_LIST_SORT_FIELDS } from './constants';

const useMcSort = () => {
  const l = useInvertedLocalize();

  const defaultSort = useMemo(
    () => ({
      value: MC_LIST_SORT_FIELDS.MITIGATINGCONTROL.value,
      order: MC_LIST_SORT_ACTIONS.ATOZ.value,
    }),
    []
  );
  const fields = useMemo(() => Object.values(MC_LIST_SORT_FIELDS), []);

  const [menu1, setMenu1] = useState(
    fields.map((field) => ({
      label: l(field.label),
      value: field.value,
      isChecked: field.value === defaultSort.value,
    })) as MenuOption[]
  );
  const [menu2, setMenu2] = useState(
    (
      fields.find((field) => field.value === defaultSort.value)?.options ?? []
    ).map((action) => ({
      label: l(MC_LIST_SORT_ACTIONS[action].label),
      value: MC_LIST_SORT_ACTIONS[action].value,
      isChecked: MC_LIST_SORT_ACTIONS[action].value === defaultSort.order,
    })) as MenuOption[]
  );

  const handleFieldClick = useCallback(
    (fieldValue: string) => {
      setMenu1((prev) =>
        prev.map((field) => ({
          ...field,
          isChecked: field.value === fieldValue,
        }))
      );

      const actionArray =
        Object.values(MC_LIST_SORT_FIELDS).find(
          (field) => field.value === fieldValue
        )?.options ?? [];

      setMenu2(
        actionArray.map((action, index) => ({
          label: l(MC_LIST_SORT_ACTIONS[action].label),
          value: MC_LIST_SORT_ACTIONS[action].value,
          isChecked: index === 0,
        }))
      );
    },
    [l]
  );

  const handleActionClick = useCallback((actionValue: string) => {
    setMenu2((prev) =>
      prev.map((field) => ({
        ...field,
        isChecked: field.value === actionValue,
      }))
    );
  }, []);

  return {
    fields: menu1,
    fieldName: menu1.find((field) => field.isChecked)?.label,
    actions: menu2,
    actionName: menu2.find((action) => action.isChecked)?.label,
    handleFieldClick,
    handleActionClick,
    activeField: menu1.find((field) => field.isChecked)?.value,
    activeAction: menu2.find((action) => action.isChecked)?.value,
  };
};

// eslint-disable-next-line import/prefer-default-export
export { useMcSort };
